import React, { useEffect, useState } from "react";
import MenuComponent from "../components/Menu/MenuComponent";
import Inventory from "./Inventory/Inventory";
import StockIn from "./StockIn/StockIn";
import History from "./History/History";
import ListBahan from "./ListBahan/ListBahan";
import QualityControl from "./QC/QualityControl";
import ListProduk from "./Produk/ListProduk";
import Dashboard from "./Dashboard/Dashboard";
import Operator from "./Operator/Operator";
import Mold from "./Mold/Mold";
import ApprovalLaporan from "./ApprovalLaporan/ApprovalLaporan";
import PatrolQc from "./PatrolQc/PatrolQc";
import Security from "./Security/Security";
import PO from "./PO/PO";
import SecondProcess from "./SecondProcess/SecondProcess";
import { useHistory } from "react-router-dom";
import ListProdukSP from "./listProdukSP/listProdukSP";
import ApprovalSP from "./ApprovalSP/ApprovalSP";
import Karantina from "./Karantina/Karantina";
import InputBarangJadi from "./InputBarangJadi/InputBarangJadi";
import BarcodeYBI from "./BarcodeYBI/BarcodeYBI";
import NewMemoPPIC from "./MemoPPIC/NewMemoPPIC";
import LemburKaryawan from "./LemburKaryawan/LemburKaryawan";
import InOutKendaraan from "./InOutKendaraan/InOutKendaraan";
import Mrp from "./monitoringBahanCustomer/mrp";
import Box from "./BOX/Box";
import GantiProduk from "./GantiProduk/GantiProduk";
import KonversiMaterial from "./KonversiMaterial/KonversiMaterial";
import LKM from "./LKM/LKM";
import Bpb from "./Bpb/Bpb";
import ChecksheetApar from "./ChecksheetApar/ChecksheetApar";
import PatrolSp from "./PatrolSp/PatrolSp";
import SuggestionSystem from "./SuggestionSystem/SuggestionSystem";
import PenilaianKaryawan from "./PenilaianKaryawan/PenilaianKaryawan";
import InputBon from "./InputBon.js/InputBon";
import Checklist5R from "./Checklist5R/Checklist5R";
import { hasRole } from "../util/utilFunction";

const IndexPage = () => {
  let history = useHistory();
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);
  const [menu, setMenu] = useState("Dashboard");

  // Urutan = prioritas. Kalau user punya beberapa role, yang cocok pertama menang.
  useEffect(() => {
    if (dataUser === null) {
      history.push("/login");
    } else if (
      hasRole(
        dataUser,
        "warehouse_admin",
        "warehouse_mixing",
        "warehouse_crusher"
      )
    ) {
      setMenu("InputBahan");
    } else if (hasRole(dataUser, "qc_user")) {
      setMenu("QC");
    } else if (hasRole(dataUser, "produksi_user")) {
      setMenu("Operator");
    } else if (hasRole(dataUser, "security")) {
      setMenu("Security");
    } else if (hasRole(dataUser, "warehouse_gbj_admin")) {
      setMenu("InputBarangJadi");
    }
  }, []);

  return (
    <div>
      {dataUser !== null ? <MenuComponent setMenu={setMenu} menu={menu} /> : ""}
      {menu === "Dashboard" ? (
        <Dashboard />
      ) : menu === "Inventory" ? (
        <Inventory />
      ) : menu === "InputBahan" ? (
        <StockIn />
      ) : menu === "History" ? (
        <History />
      ) : menu === "ListBahan" ? (
        <ListBahan />
      ) : menu === "QC" ? (
        <QualityControl />
      ) : menu === "Produk" ? (
        <ListProduk />
      ) : menu === "Operator" ? (
        <Operator />
      ) : menu === "ApprovalLaporan" ? (
        <ApprovalLaporan />
      ) : menu === "Mold" ? (
        <Mold />
      ) : menu === "Patrol" ? (
        <PatrolQc />
      ) : menu === "PO" ? (
        <PO />
      ) : menu === "SP" ? (
        <SecondProcess />
      ) : menu === "listProdukSP" ? (
        <ListProdukSP />
      ) : menu === "ApprovalLaporanSP" ? (
        <ApprovalSP />
      ) : menu === "Security" ? (
        <Security />
      ) : menu === "Karantina" ? (
        <Karantina />
      ) : menu === "InputBarangJadi" ? (
        <InputBarangJadi />
      ) : menu === "BarcodeYBI" ? (
        <BarcodeYBI />
      ) : menu === "NewMemoPPIC" ? (
        <NewMemoPPIC />
      ) : menu === "LemburKaryawan" ? (
        <LemburKaryawan />
      ) : menu === "InputBox" ? (
        <Box />
      ) : menu === "DowntimeGantiProduk" ? (
        <GantiProduk />
      ) : menu === "MonitorKonversiMaterial" ? (
        <KonversiMaterial />
      ) : menu === "Bpb" ? (
        <Bpb />
      ) : menu === "LKM" ? (
        <LKM />
      ) : menu === "mrp" ? (
        <Mrp />
      ) : menu === "Apar" ? (
        <ChecksheetApar />
      ) : menu === "PatrolSp" ? (
        <PatrolSp />
      ) : menu === "SuggestionSystem" ? (
        <SuggestionSystem />
      ) : menu === "PenilaianKaryawan" ? (
        <PenilaianKaryawan />
      ) : menu === "InputBon" ? (
        <InputBon />
      ) : menu === "Checklist 5R" ? (
        <Checklist5R />
      ) : menu === "InOutKendaraan" ? (
        <InOutKendaraan />
      ) : (
        ""
      )}
    </div>
  );
};
export default IndexPage;
